// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".photo[data-v-6c006654] {\n  width: 110px;\n  -o-object-fit: cover;\n     object-fit: cover;\n}", ""]);
// Exports
module.exports = exports;
